<template>
    <div class="max-width-content">
        <!-- <trashed-message v-if="place.deleted_at" class="mb-6" @restore="restore">
            This place has been deleted.
        </trashed-message> -->

        <breadcrumbs>
            <inertia-link href="/places">Plaatsen</inertia-link>
            <i class="fad fa-chevron-right"></i>
            <inertia-link :href="route('admin.places.show', place.id)">{{ place.name | truncate(35) }}</inertia-link>
            <i class="fad fa-chevron-right"></i>
            Wijzig
        </breadcrumbs>

        <div class="mt-5 bg-white rounded-lg px-8 py-5">
            <place-form :place="place" @submit="submit" :data-loading="loading"></place-form>
        </div>
    </div>
</template>

<script>
import Layout from "@/admin/Shared/Layout";
import Helpers from "@/admin/Mixins/GeneralHelpers.js";
import Breadcrumbs from "@/admin/Shared/Breadcrumbs";
// import TrashedMessage from "@/admin/Shared/TrashedMessage";
import PlaceForm from "@/admin/Pages/Places/PlaceForm";

export default {
    metaInfo() {
        return { title: this.place.name };
    },

    layout: (h, page) => h(Layout, [page]),

    components: {
        // TrashedMessage,
        Breadcrumbs,
        PlaceForm
    },

    mixins: [Helpers],

    props: {
        place: Object
    },

    remember: "form",

    data() {
        return {
            form: {
                name: this.place.name,
                image: null,
                seotext1: this.place.seotext1,
                seotext2: this.place.seotext2
            }
        };
    },

    methods: {
        submit(data) {
            this.loading = "submit";

            const url = this.route("admin.places.update", this.place.id).url();
            const options = { onFinish: () => this.loading = false}

            this.$inertia.patch(url, data, options)
        }
    }
};
</script>
